module.exports = __webpack_public_path__ + "static/BT-mobile-14-e1ea75e479436bfb26b88d371e324c16.jpg";